// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aPy0","right":"styles_right__KnHta"};